import { Stack, TextInput, Textarea } from "@mantine/core";
import { measurementUnitApi } from "apis";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { MeasurementUnitRequest } from "constants/types/measurement";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/MeasurementUnit/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import { createValidationSchema } from "./config";

type Props = {
  onClose?: () => void;
  mutate?: () => void;
};

const CreateForm: FC<Props> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<MeasurementUnitRequest>({
    initialValues: {
      code: "",
      name: "",
      notes: "",
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await measurementUnitApi.create(values);
        notification.success({ title: "Tạo đơn vị tính thành công" });
        onClose?.();
        mutate?.();
        formik.resetForm();
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Tạo đơn vị tính thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
        <Stack gap="sm">
          <TextInput
            label="Mã đơn vị tính"
            placeholder="VD: KG, L, M..."
            withAsterisk
            {...formik.getFieldProps("code")}
            error={formik.touched.code && formik.errors.code}
          />
          <TextInput
            label="Tên đơn vị tính"
            placeholder="VD: Kilogram, Lít, Mét..."
            withAsterisk
            {...formik.getFieldProps("name")}
            error={formik.touched.name && formik.errors.name}
          />
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú (tuỳ chọn)"
            autosize
            minRows={2}
            {...formik.getFieldProps("notes")}
            error={formik.touched.notes && formik.errors.notes}
          />
        </Stack>
      </form>
    </Loading>
  );
};

export default CreateForm;
